module.exports = __webpack_public_path__ + "static/media/8-4.4b0eaf5d.svg";